const copyBtns = document.querySelectorAll('.copy-page, .a2a_button_copy_link');

copyBtns?.forEach(btn => {
  btn.addEventListener('click', event => {
    event.preventDefault();
    const pageURL = window.location.href;

    function onCopied() {
      btn.classList.add('is-copy');

      if (btn.timer) {
        clearTimeout(btn.timer);
      }

      btn.timer = setTimeout(() => {
        btn.classList.remove('is-copy');
        btn.timer = null;
      }, 1000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(pageURL)
        .then(onCopied)
        .catch(err => console.error('Помилка при копіюванні: ', err));
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = pageURL;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        document.execCommand('copy');
        onCopied();
      } catch (err) {
        console.error('Помилка при копіюванні: ', err);
      }

      document.body.removeChild(textarea);
    }
  });
});

document.querySelectorAll('.a2a_button_copy_link[title]').forEach(a => {
  const span = document.createElement('span');
  span.textContent = a.getAttribute('title');
  a.appendChild(span);
});
